import { render, staticRenderFns } from "./centralaz.vue?vue&type=template&id=6806d410&"
import script from "./centralaz.vue?vue&type=script&lang=js&"
export * from "./centralaz.vue?vue&type=script&lang=js&"
import style0 from "./centralaz.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports